import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs } from '@blueprintjs/core';
import history from '../../../../../helpers/history';

import ReceiptsPanel from './progress-panels/Receipts';
import PhotosPanel from './progress-panels/Photos';
import ThankYouNotesPanel from './progress-panels/ThankYouNotes';
import ReportCardsPanel from './progress-panels/ReportCards';
import RecipientAppsPanel from './progress-panels/RecipientApps';
import RecipientMiscDocsPanel from './progress-panels/RecipientMiscDocs';

import RecipientProgress from './RecipientProgress';

class ProgressTabs extends Component {
    handleTabChange = newTab => {
        const { match: {params: { progressId, clientId, tab }} } = this.props;
        if (tab !== newTab) {
            history.push(`/dashboard/recipients/${clientId}/${progressId}/${newTab}`);
        }
    }
    render() {
        const { match: {params: { progressId, clientId, tab }}, recipientState } = this.props;
        return (
            <Tabs large onChange={this.handleTabChange} selectedTabId={tab} renderActiveTabPanelOnly={true}>
                <Tab id="photos" className={{'selected': tab === 'photos' || !tab}} title="Photos" panel={<PhotosPanel recipientId={clientId} progressId={progressId} recipientState={recipientState} />} />
                <Tab id="receipts" className={{'selected': tab === 'receipts'}} title="Receipts" panel={<ReceiptsPanel recipientId={clientId} progressId={progressId} recipientState={recipientState} />} />
                <Tab id="thankYouNotes" className={{'selected': tab === 'thankYouNotes'}} title="Thank You Notes" panel={<ThankYouNotesPanel recipientId={clientId} progressId={progressId} recipientState={recipientState} />} />
                <Tab id="reportCards" className={{'selected': tab === 'reportCards'}} title="Report Cards" panel={<ReportCardsPanel recipientId={clientId} progressId={progressId} recipientState={recipientState} />} />
                <Tab id="recipientApps" className={{'selected': tab === 'recipientApps'}} title="Applications" panel={<RecipientAppsPanel recipientId={clientId} progressId={progressId} recipientState={recipientState} />} />
                <Tab id="recipientMiscDocs" className={{'selected': tab === 'recipientMiscDocs'}} title="Other Documents" panel={<RecipientMiscDocsPanel recipientId={clientId} progressId={progressId} recipientState={recipientState} />} />
                <Tabs.Expander />
            </Tabs>
        );
    }
}

const AddButton = props => {
    return (
        <button type="button"
            className="pt-button pt-small pt-intent-primary pt-icon-add"
            onClick={props.onClick}>
            {props.title}
        </button>
    )
};

class ProgressHeader extends Component {
    shouldComponentUpdate(nextProps) {
        return (this.props.match.params.progressId !== nextProps.match.params.progressId) ||
            (this.props.progress.progressesById !== nextProps.progressesById);
    }
    openSectionModal = (type) => {
        const customEvent = new CustomEvent(type, {detail: {
            ...this.props.match.params,
            recipientId: this.props.match.params.clientId
        }});
        window.dispatchEvent(customEvent);
    }
    render() {
        const { progress: { progressesById }, tab} = this.props;
        const { progressId } = this.props.match.params;
        let headerComponent, fixedComponent;
        if (progressId) {
            const currentProgress = progressesById[progressId];
            headerComponent = (
                <h4>
                    <span onClick={() => this.props.goBack()} className="back-icon pt-icon-standard pt-icon-circle-arrow-left"></span>
                    Student Progress For Year <span style={{marginLeft: '5px'}}><strong>{currentProgress ? currentProgress.year_begin : ''}</strong></span>
                </h4>
            );
            switch (tab) {
                case undefined:
                case 'photos':
                    fixedComponent = <AddButton title="Add Photo" onClick={() => this.openSectionModal('open-photo-modal')} />
                    break;
                case 'receipts':
                    fixedComponent = <AddButton title="Add Receipt" onClick={() => this.openSectionModal('open-receipt-modal')} />
                    break;
                case 'thankYouNotes':
                    fixedComponent = <AddButton title="Add Thank You Note" onClick={() => this.openSectionModal('open-thank-you-note-modal')} />
                    break;
                case 'reportCards':
                    fixedComponent = <AddButton title="Add Report Card" onClick={() => this.openSectionModal('open-report-card-modal')} />
                    break;
                case 'recipientApps':
                    fixedComponent = <AddButton title="Add Application" onClick={() => this.openSectionModal('open-recipient-app-modal')} />
                    break;
                case 'recipientMiscDocs':
                    fixedComponent = <AddButton title="Add Other Document" onClick={() => this.openSectionModal('open-recipient-misc-doc-modal')} />
                    break;
                default:
                    break;
            }
        } else {
            headerComponent = <h4>All Student Progresses</h4>;
            fixedComponent = (
                <button type="button"
                    className="pt-button pt-small pt-intent-primary pt-icon-add"
                    onClick={(event) => this.props.openModal({ event, rowData: null })}>
                    Add Progress
                </button>
            );
        }
        return (
            <div className="panel-title">
                <span className="panel-title-flex">{headerComponent}</span>
                { fixedComponent ? <span className="panel-title-fixed">{fixedComponent}</span> : null }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    progress: state.progress
});
const ProgressHeaderContainer = connect(
    mapStateToProps,
    {}
)(ProgressHeader);

class RecipientProgressView extends Component {
    goBack = () => {
        const { params: { clientId }} = this.props.match
        history.push(`/dashboard/recipients/${clientId}`);
    }
    openModal = ({ rowData, event }) => {
        event.preventDefault();
        event.stopPropagation();
        const { params: { clientId }} = this.props.match;
        const form = rowData ? { ...rowData, recipientId: clientId } : { recipientId: clientId };
        const customEvent = new CustomEvent(('open-progress-modal'), { detail: form });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { params: { progressId, clientId, tab }} = this.props.match;
        return (
            <Fragment>
                <ProgressHeaderContainer
                    match={this.props.match}
                    tab={tab}
                    goBack={this.goBack}
                    openModal={this.openModal} />
                <div className="panel-progress panel-content">
                    { progressId ?
                        <ProgressTabs {...this.props} /> :
                        <RecipientProgress openModal={this.openModal} recipientId={clientId} />
                    }
                </div>
            </Fragment>
        );
    }
}

export default withRouter(RecipientProgressView);


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/RecipientProgressView.jsx